const PatientOverview = () => {
  return <div>patient overview</div>;
};

export default PatientOverview;
